export default "__VITE_ASSET__HxLEi6ym__"